'use strict';

/**
 * @generated SignedSource<<fcd7562b761e59f9a9ef318a97477328>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cartId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "channel"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "channel",
        "variableName": "channel"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cartId",
            "variableName": "cartId"
        },
        (v1 /*: any*/)
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "offerId",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "DeliveryItemsFieldQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v2 /*: any*/),
                    "concreteType": "Cart",
                    "kind": "LinkedField",
                    "name": "cart",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "DeliveryItemsFieldFragment"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "DeliveryItemsFieldQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v2 /*: any*/),
                    "concreteType": "Cart",
                    "kind": "LinkedField",
                    "name": "cart",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Item",
                            "kind": "LinkedField",
                            "name": "shippableItems",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "imageUrl",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "itemId",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "quantity",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "title",
                                    "storageKey": null
                                },
                                (v3 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": [
                                (v1 /*: any*/)
                            ],
                            "concreteType": "ProductOfferImage",
                            "kind": "LinkedField",
                            "name": "productOfferImages",
                            "plural": true,
                            "selections": [
                                (v3 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "url",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "type",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "14d42b8b8972cc102b953ec53e6a793d",
            "id": null,
            "metadata": {},
            "name": "DeliveryItemsFieldQuery",
            "operationKind": "query",
            "text": "query DeliveryItemsFieldQuery(\n  $cartId: String\n  $channel: CartChannel!\n) {\n  cart(cartId: $cartId, channel: $channel) {\n    ...DeliveryItemsFieldFragment\n    id\n  }\n}\n\nfragment DeliveryItemsFieldFragment on Cart {\n  shippableItems {\n    imageUrl\n    itemId\n    quantity\n    title\n    offerId\n  }\n  productOfferImages(channel: $channel) {\n    offerId\n    url\n    type\n  }\n}\n"
        }
    };
})();
node.hash = "c4ddc11942b6d726d819a58d4514aa05";

module.exports = node;
